import React, { useLayoutEffect, useRef } from 'react';
import { lang } from '../lang';
import SwiperCarousel from './SwiperCarousel';

const Panelists = () => {
  const panelistsData = lang.panelists;
  const containerRef = useRef();
  useLayoutEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.1) {
            entry.target.style.animation = 'fade-in 0.5s linear forwards';
          }
        });
      },
      { threshold: [0, 0.1] }
    );

    observer.observe(containerRef.current);
  }, []);
  return (
    <section className="panelists" ref={containerRef}>
      <h3>{panelistsData.head}</h3>
      <SwiperCarousel data={panelistsData.content} />
    </section>
  );
};

export default Panelists;
